import React from "react";

export default function CarouselIndicators({ activeIndex = 0, items = [] }) {
  if (!items || items.length === 0) return null;

  const finalActiveIndex = items.length === 1 ? 0 : activeIndex;

  return (
    <div className="carousel-indicators">
      {items.map((icon, index) => (
        <button key={index} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} className={`position-relative ${finalActiveIndex === index ? "active" : ""}`} aria-current={finalActiveIndex === index} aria-label={`Slide ${index + 1}`}>
          <div className="rounded-5 bg-100 position-absolute top-50 start-0 translate-middle d-flex justify-content-center align-items-center">
            <i className={`fa-solid fa-${icon}`}></i>
          </div>
        </button>
      ))}
    </div>
  );
}
